"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/tag/v1/admin_service.proto (package spwn.tag.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminTagServiceRemoveTagFromGoodsResponse = exports.AdminTagServiceRemoveTagFromGoodsRequest = exports.AdminTagServiceAddTagToGoodsResponse = exports.AdminTagServiceAddTagToGoodsRequest = exports.AdminTagServiceDeleteTagResponse = exports.AdminTagServiceDeleteTagRequest = exports.AdminTagServiceUpdateTagResponse = exports.AdminTagServiceUpdateTagRequest = exports.AdminTagServiceAddTagResponse = exports.AdminTagServiceAddTagRequest = exports.AdminTagServiceGetTagByIdResponse = exports.AdminTagServiceGetTagByIdRequest = exports.AdminTagServiceGetTagsResponse = exports.AdminTagServiceGetTagsRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const admin_common_pb_1 = require("./admin_common_pb");
/**
 * @generated from message spwn.tag.v1.AdminTagServiceGetTagsRequest
 */
class AdminTagServiceGetTagsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ブランドID
         *
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTagServiceGetTagsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTagServiceGetTagsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTagServiceGetTagsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTagServiceGetTagsRequest, a, b);
    }
}
exports.AdminTagServiceGetTagsRequest = AdminTagServiceGetTagsRequest;
AdminTagServiceGetTagsRequest.runtime = protobuf_1.proto3;
AdminTagServiceGetTagsRequest.typeName = "spwn.tag.v1.AdminTagServiceGetTagsRequest";
AdminTagServiceGetTagsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tag_category", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "tag_display_type", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "tag_keyword", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.tag.v1.AdminTagServiceGetTagsResponse
 */
class AdminTagServiceGetTagsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * タグリスト
         *
         * @generated from field: repeated spwn.tag.v1.AdminTag tags = 1;
         */
        this.tags = [];
        /**
         * トータル件数
         *
         * @generated from field: int32 total_count = 2;
         */
        this.totalCount = 0;
        /**
         * 最後のページ番号
         *
         * @generated from field: int32 last_page_number = 3;
         */
        this.lastPageNumber = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTagServiceGetTagsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTagServiceGetTagsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTagServiceGetTagsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTagServiceGetTagsResponse, a, b);
    }
}
exports.AdminTagServiceGetTagsResponse = AdminTagServiceGetTagsResponse;
AdminTagServiceGetTagsResponse.runtime = protobuf_1.proto3;
AdminTagServiceGetTagsResponse.typeName = "spwn.tag.v1.AdminTagServiceGetTagsResponse";
AdminTagServiceGetTagsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tags", kind: "message", T: admin_common_pb_1.AdminTag, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "last_page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.tag.v1.AdminTagServiceGetTagByIdRequest
 */
class AdminTagServiceGetTagByIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * タグID
         *
         * @generated from field: string tag_id = 1;
         */
        this.tagId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTagServiceGetTagByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTagServiceGetTagByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTagServiceGetTagByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTagServiceGetTagByIdRequest, a, b);
    }
}
exports.AdminTagServiceGetTagByIdRequest = AdminTagServiceGetTagByIdRequest;
AdminTagServiceGetTagByIdRequest.runtime = protobuf_1.proto3;
AdminTagServiceGetTagByIdRequest.typeName = "spwn.tag.v1.AdminTagServiceGetTagByIdRequest";
AdminTagServiceGetTagByIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.tag.v1.AdminTagServiceGetTagByIdResponse
 */
class AdminTagServiceGetTagByIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTagServiceGetTagByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTagServiceGetTagByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTagServiceGetTagByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTagServiceGetTagByIdResponse, a, b);
    }
}
exports.AdminTagServiceGetTagByIdResponse = AdminTagServiceGetTagByIdResponse;
AdminTagServiceGetTagByIdResponse.runtime = protobuf_1.proto3;
AdminTagServiceGetTagByIdResponse.typeName = "spwn.tag.v1.AdminTagServiceGetTagByIdResponse";
AdminTagServiceGetTagByIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tag", kind: "message", T: admin_common_pb_1.AdminTag },
]);
/**
 * @generated from message spwn.tag.v1.AdminTagServiceAddTagRequest
 */
class AdminTagServiceAddTagRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * タグ名
         *
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * カテゴリ
         *
         * @generated from field: string category = 5;
         */
        this.category = "";
        /**
         * 表示種別
         *
         * @generated from field: string display_type = 6;
         */
        this.displayType = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTagServiceAddTagRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTagServiceAddTagRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTagServiceAddTagRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTagServiceAddTagRequest, a, b);
    }
}
exports.AdminTagServiceAddTagRequest = AdminTagServiceAddTagRequest;
AdminTagServiceAddTagRequest.runtime = protobuf_1.proto3;
AdminTagServiceAddTagRequest.typeName = "spwn.tag.v1.AdminTagServiceAddTagRequest";
AdminTagServiceAddTagRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "kana_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "english_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "display_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.tag.v1.AdminTagServiceAddTagResponse
 */
class AdminTagServiceAddTagResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTagServiceAddTagResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTagServiceAddTagResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTagServiceAddTagResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTagServiceAddTagResponse, a, b);
    }
}
exports.AdminTagServiceAddTagResponse = AdminTagServiceAddTagResponse;
AdminTagServiceAddTagResponse.runtime = protobuf_1.proto3;
AdminTagServiceAddTagResponse.typeName = "spwn.tag.v1.AdminTagServiceAddTagResponse";
AdminTagServiceAddTagResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tag", kind: "message", T: admin_common_pb_1.AdminTag },
]);
/**
 * @generated from message spwn.tag.v1.AdminTagServiceUpdateTagRequest
 */
class AdminTagServiceUpdateTagRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * タグID
         *
         * @generated from field: string tag_id = 1;
         */
        this.tagId = "";
        /**
         * タグ名
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * カテゴリ
         *
         * @generated from field: string category = 6;
         */
        this.category = "";
        /**
         * 表示種別
         *
         * @generated from field: string display_type = 7;
         */
        this.displayType = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTagServiceUpdateTagRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTagServiceUpdateTagRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTagServiceUpdateTagRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTagServiceUpdateTagRequest, a, b);
    }
}
exports.AdminTagServiceUpdateTagRequest = AdminTagServiceUpdateTagRequest;
AdminTagServiceUpdateTagRequest.runtime = protobuf_1.proto3;
AdminTagServiceUpdateTagRequest.typeName = "spwn.tag.v1.AdminTagServiceUpdateTagRequest";
AdminTagServiceUpdateTagRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "kana_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "english_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "display_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.tag.v1.AdminTagServiceUpdateTagResponse
 */
class AdminTagServiceUpdateTagResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTagServiceUpdateTagResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTagServiceUpdateTagResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTagServiceUpdateTagResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTagServiceUpdateTagResponse, a, b);
    }
}
exports.AdminTagServiceUpdateTagResponse = AdminTagServiceUpdateTagResponse;
AdminTagServiceUpdateTagResponse.runtime = protobuf_1.proto3;
AdminTagServiceUpdateTagResponse.typeName = "spwn.tag.v1.AdminTagServiceUpdateTagResponse";
AdminTagServiceUpdateTagResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tag", kind: "message", T: admin_common_pb_1.AdminTag },
]);
/**
 * @generated from message spwn.tag.v1.AdminTagServiceDeleteTagRequest
 */
class AdminTagServiceDeleteTagRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * タグID
         *
         * @generated from field: string tag_id = 1;
         */
        this.tagId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTagServiceDeleteTagRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTagServiceDeleteTagRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTagServiceDeleteTagRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTagServiceDeleteTagRequest, a, b);
    }
}
exports.AdminTagServiceDeleteTagRequest = AdminTagServiceDeleteTagRequest;
AdminTagServiceDeleteTagRequest.runtime = protobuf_1.proto3;
AdminTagServiceDeleteTagRequest.typeName = "spwn.tag.v1.AdminTagServiceDeleteTagRequest";
AdminTagServiceDeleteTagRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.tag.v1.AdminTagServiceDeleteTagResponse
 */
class AdminTagServiceDeleteTagResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 削除対象のID
         *
         * @generated from field: string tag_id = 1;
         */
        this.tagId = "";
        /**
         * リクエストによって削除されたか
         *
         * @generated from field: bool is_deleted = 2;
         */
        this.isDeleted = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTagServiceDeleteTagResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTagServiceDeleteTagResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTagServiceDeleteTagResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTagServiceDeleteTagResponse, a, b);
    }
}
exports.AdminTagServiceDeleteTagResponse = AdminTagServiceDeleteTagResponse;
AdminTagServiceDeleteTagResponse.runtime = protobuf_1.proto3;
AdminTagServiceDeleteTagResponse.typeName = "spwn.tag.v1.AdminTagServiceDeleteTagResponse";
AdminTagServiceDeleteTagResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.tag.v1.AdminTagServiceAddTagToGoodsRequest
 */
class AdminTagServiceAddTagToGoodsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * タグID
         *
         * @generated from field: string tag_id = 1;
         */
        this.tagId = "";
        /**
         * グッズID(複数)
         *
         * @generated from field: repeated string goods_ids = 2;
         */
        this.goodsIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTagServiceAddTagToGoodsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTagServiceAddTagToGoodsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTagServiceAddTagToGoodsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTagServiceAddTagToGoodsRequest, a, b);
    }
}
exports.AdminTagServiceAddTagToGoodsRequest = AdminTagServiceAddTagToGoodsRequest;
AdminTagServiceAddTagToGoodsRequest.runtime = protobuf_1.proto3;
AdminTagServiceAddTagToGoodsRequest.typeName = "spwn.tag.v1.AdminTagServiceAddTagToGoodsRequest";
AdminTagServiceAddTagToGoodsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "goods_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.tag.v1.AdminTagServiceAddTagToGoodsResponse
 */
class AdminTagServiceAddTagToGoodsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 指定タグが紐づいた状態になったグッズIDリスト
         * リクエストで新しく紐づけたIDと既に紐づいていたID両方含む
         *
         * @generated from field: repeated string goods_ids = 1;
         */
        this.goodsIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTagServiceAddTagToGoodsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTagServiceAddTagToGoodsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTagServiceAddTagToGoodsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTagServiceAddTagToGoodsResponse, a, b);
    }
}
exports.AdminTagServiceAddTagToGoodsResponse = AdminTagServiceAddTagToGoodsResponse;
AdminTagServiceAddTagToGoodsResponse.runtime = protobuf_1.proto3;
AdminTagServiceAddTagToGoodsResponse.typeName = "spwn.tag.v1.AdminTagServiceAddTagToGoodsResponse";
AdminTagServiceAddTagToGoodsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.tag.v1.AdminTagServiceRemoveTagFromGoodsRequest
 */
class AdminTagServiceRemoveTagFromGoodsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * タグID
         *
         * @generated from field: string tag_id = 1;
         */
        this.tagId = "";
        /**
         * グッズID(複数)
         *
         * @generated from field: repeated string goods_ids = 2;
         */
        this.goodsIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTagServiceRemoveTagFromGoodsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTagServiceRemoveTagFromGoodsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTagServiceRemoveTagFromGoodsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTagServiceRemoveTagFromGoodsRequest, a, b);
    }
}
exports.AdminTagServiceRemoveTagFromGoodsRequest = AdminTagServiceRemoveTagFromGoodsRequest;
AdminTagServiceRemoveTagFromGoodsRequest.runtime = protobuf_1.proto3;
AdminTagServiceRemoveTagFromGoodsRequest.typeName = "spwn.tag.v1.AdminTagServiceRemoveTagFromGoodsRequest";
AdminTagServiceRemoveTagFromGoodsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "goods_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.tag.v1.AdminTagServiceRemoveTagFromGoodsResponse
 */
class AdminTagServiceRemoveTagFromGoodsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 指定タグとの紐づけが解除された状態になったグッズIDリスト
         * リクエストで新しく解除したIDと元から紐づいていなかったID両方含む
         *
         * @generated from field: repeated string goods_ids = 1;
         */
        this.goodsIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTagServiceRemoveTagFromGoodsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTagServiceRemoveTagFromGoodsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTagServiceRemoveTagFromGoodsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTagServiceRemoveTagFromGoodsResponse, a, b);
    }
}
exports.AdminTagServiceRemoveTagFromGoodsResponse = AdminTagServiceRemoveTagFromGoodsResponse;
AdminTagServiceRemoveTagFromGoodsResponse.runtime = protobuf_1.proto3;
AdminTagServiceRemoveTagFromGoodsResponse.typeName = "spwn.tag.v1.AdminTagServiceRemoveTagFromGoodsResponse";
AdminTagServiceRemoveTagFromGoodsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
//# sourceMappingURL=admin_service_pb.js.map